// gloss
export const safeParseDate = (dateStr?: string | null): Date | null => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  return isNaN(d.getTime()) ? null : d;
};

// gloss
// why: date-only strings must be parsed as local midnight (append T00:00:00, no Z) — UTC-midnight
// why: parsing rolls back a day.
export const parseDateOnly = (dateStr?: string | null): Date | null => {
  if (!dateStr) return null;
  if (dateStr.includes('T')) return safeParseDate(dateStr);
  const d = new Date(`${dateStr}T00:00:00`);
  return isNaN(d.getTime()) ? null : d;
};
